import { CommonRootState } from '../combineReducers';
import { ThunkAction } from 'redux-thunk';

export const removeSnackbar = (key: number): ThunkAction<void, CommonRootState, null, Actions> => async dispatch =>
  dispatch(removeSnackbarRequest(key));

const removeSnackbarRequest = (payload: number) =>
  ({
    type: 'REMOVE_SNACKBAR',
    payload
  } as const);

export type Actions = ReturnType<typeof removeSnackbarRequest>;
